/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    authenticationFormCard: {
      padding: theme.spacing(3.5),
      boxSizing: 'border-box',
      maxWidth: theme.spacing(48),
      width: '100%',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    authenticationFormCardContent: {
      width: '100%',
    },
    authenticationFormCardContentEmbedded: {
      width: '100%',
      maxWidth: theme.spacing(32),
    },
    choreoLogo: {},
    choreoSignUpLink: {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'default',
    },
    choreMoreDetails: {},
    otherLinks: {
      color: theme.palette.secondary.main,
    },
  })
);
